import { AfterViewInit, Directive, ElementRef, HostBinding, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { unpatchAddEventListener } from '@rx-angular/cdk/zone-less/browser';
import { stopAndPreventEvent } from '@utils/dom/event';
import { isEmpty } from '@utils/type';
import { DEFAULT_IDENTITTY } from '../constants';
import { HighlightMeController } from '../services';

@Directive({
  selector: '[highlightMeActor]',
  standalone: true
})
export class HighlightMeActorDirective implements OnInit, OnDestroy, AfterViewInit {

  @HostBinding('mouseenter')

  @Input('actors')
  set actors(actors: string[]) { this.#actors = actors; }
  get actors(): string[] { return this.#actors.map(a => a); }
  #actors: string[] = [DEFAULT_IDENTITTY];

  #elementRef = inject(ElementRef);
  #controller = inject(HighlightMeController);

  constructor() { }

  get domElement(): HTMLElement { return this.#elementRef.nativeElement; }

  ngOnInit() {
    unpatchAddEventListener(this.domElement);
  }

  ngAfterViewInit() {
    if (!isEmpty(this.#actors)) {
      this.domElement.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.domElement.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  ngOnDestroy() {
    this.domElement.removeEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.domElement.removeEventListener('mouseleave', this.onMouseEnter.bind(this));
  }

  private onMouseEnter(event: MouseEvent) {
    stopAndPreventEvent(event);
    this.#controller.focus(this);
  }

  private onMouseLeave(event: MouseEvent) {
    stopAndPreventEvent(event);
    this.#controller.blur(this);
  }

}
